import React from "react";
import DownBox from "../DownloadSection/DownloadCard";
const DownloadSection = ({ brochureData }) => {
  return (
    <section className="section-space pt-0">
      <div className="container-xl">
        <div className="row">
          <div className="col-lg-6 col-md-6">
            <DownBox
              brochureText={brochureData?.brochure_one_text}
              brochureImg={brochureData?.brochure_one}
            />
          </div>
          <div className="col-lg-6 col-md-6">
            <DownBox
              brochureText={brochureData?.brochure_two_text}
              brochureImg={brochureData?.brochure_two}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default DownloadSection;
